export default {
    'ptBR': {
        Cardapios: 'Cardápios',

        NossosServicos: 'Nossos Serviços',
        Estacionamento: 'Estacionamento',
        FilaDeEspera: 'Fila de Espera',
        AreaPet: 'Área Pet',

        SaibaMais: 'saiba mais',
        VejaMais: 'Veja Mais',

        HappyEPromocoes: 'Happy e Promoções',
        Eventos: 'Eventos Corporativos e Aniversários',
        Reservas: 'Reservas',
        DeliveryIfood: 'Delivery Ifood',
        DeliveryRappi: 'Delivery Rappi',
        Informacoes: 'Informações',
        Waze: 'Waze',
        TripAdvisor: 'Trip Advisor',
        PesquisaDeSatisfacao: 'Pesquisa de Satisfação',
        FormasDePagamento: 'Formas de Pagamento',

        DetalhesDoItem: 'Detalhes do Item',
        Descricao: 'Descrição',
        APartirDe: 'A partir de',
        EscolhaUmaOpcao: 'Escolha uma opção',
        FiltrarPorPais: 'Filtrar por País',
        FiltrarPorUvas: 'Filtrar por Uvas',
        Todos: 'Todos',
        CliqueAquiParaFazerSuaReserva: 'Clique aqui para fazer sua reserva',
        NaoEncontrado: 'Não Encontrado',

        Funcionamento: 'Funcionamento',
        Valores: 'Valores',

        CartoesCredito: 'Cartões de Crédito',
        CartoesDebito: 'Cartões de Débito',
        CartoesRefeicao: 'Cartões de Refeição',

        OlaGostariaInformacoes: 'Olá, gostaria de informações',
        OlaGostariaInformacoesEventos: 'Olá, gostaria de informações sobre os eventos corporativos e aniversários',

        RedesSociais: 'Redes Sociais',

        SeuCardapioOnlineDigital: 'Seu Cardápio Online e Digital'
    },
    'enUS': {
        Cardapios: 'Menus',

        NossosServicos: 'Our Services',
        Estacionamento: 'Parking',
        FilaDeEspera: 'Queue',
        AreaPet: 'Pet Area',

        SaibaMais: 'learn more',
        VejaMais: 'See More',

        HappyEPromocoes: 'Promotions',
        Eventos: 'Corporate Event and Birthday',
        Reservas: 'Reservations',
        DeliveryIfood: 'Delivery Ifood',
        DeliveryRappi: 'Delivery Rappi',
        Informacoes: 'Information',
        Waze: 'Waze',
        TripAdvisor: 'Trip Advisor',
        PesquisaDeSatisfacao: 'Pesquisa de Satisfação',
        FormasDePagamento: 'Payment Methods',

        DetalhesDoItem: 'Item Details',
        Descricao: 'Description',
        APartirDe: 'From',
        EscolhaUmaOpcao: 'Choose an option',
        FiltrarPorPais: 'Filter by Country',
        FiltrarPorUvas: 'Filter by Grapes',
        Todos: 'All',
        CliqueAquiParaFazerSuaReserva: 'Click here to make your reservation',
        NaoEncontrado: 'Not Found',

        Funcionamento: 'Opening hours',
        Valores: 'Values',

        CartoesCredito: 'Credit Cards',
        CartoesDebito: 'Debit Cards',
        CartoesRefeicao: 'Meal Cards',

        OlaGostariaInformacoes: 'Hi, I would like information',
        OlaGostariaInformacoesEventos: 'Hi, I would like information about Corporate Events and Birthday.',

        RedesSociais: 'Social Media',

        SeuCardapioOnlineDigital: 'Your Menu Online and Digital'
    }
}